import React from "react";

import IconSearch from "components/Icon/Search";
import UIInput from "components/UI/Input";

const UIInputSearch = React.forwardRef((props, ref) => (
  <UIInput {...props} ref={ref} iconLeft={<IconSearch />} />
));

export default UIInputSearch;
